import "./ExecutiveCommittee.scss";
import TableComponent from '../../components/Table/TableComponent';
import aluminiPages from "../AluminiPages.json";
import AluminiDynamicPages from '../AluminiDynamicPages';

const ExecutiveCommittee = () => {

    const executiveCommittee = aluminiPages.executiveCommittee[0];
    const columns = ["S.No.", "Name", "Designation & Department","Position", "Email ID"];
    const rows = [
        { name: "Dr. S. Poornima", designation: "Assistant Professor, Dept. of Biotechnology", position: "President", email :"poornima.nicas@gmail.com" },
        { name: "Mrs. Uma Nageswari", designation: "Assistant Professor, Dept. of Microbiology", position: "Secretary", email :"umaselvendran85@gmail.com"  },
        { name: "Mrs. Meera Sabari", designation: "Assistant Professor, Dept. of Biotechnology", position: "Treasurer", email :"meerabiotech11@gmail.com"  },
        { name: "Janab Dr. A. P. Majeed Khan", designation: "Secretary NICAS", position: "Executive Member", email :"nicollege2001@yahoo.co.in" },
        { name: "Dr. R. Marimuthu", designation: "Principal NICAS", position: "Executive Member", email : "balumarimuthukarur@gmail.com" },
        { name: "Mrs. S. T. Deepa", designation: "Asst.Prof. & Head, Department of Information Technology", position: "Executive Member", email : "deepapramod1972@gmail.com" },
        { name: "Mrs. S. S. Rekha", designation: "Assistant Professor, Dept. of Commerce", position: "Executive Member", email : "ssrekha41@gmail.com"  },
        { name: "Miss. S. Sajna Beevi", designation: "Alumini / Asst. Prof. Of English", position: "Executive Member", email : "sajnahameed278@gmail.com"  },
        { name: "Mrs. R. AshaNarayani", designation: "Alumini / Asst. Prof. Of Information Technology", position: "Executive Member", email :"ashanarayani1987@gmail.com"  },
        { name: "Mrs. M. Raziya Fathima", designation: "Alumini / Asst. Prof. Of Biotechnology", position: "Executive Member", email :"razibiotech24@gmail.com"  },
        { name: "Mrs. G. A. Authira", designation: "Alumini / Asst. Prof. Of Biotechnology", position: "Executive Member", email :"authiraga@gmail.com"  }

    ];

    return (
        <section className="executiveCommitteeMainContainer">
            <article className="firstSection">
                <AluminiDynamicPages
                    title={executiveCommittee.title}
                    content={executiveCommittee.content}
                />
            </article>
            <article className="secondSection">
                <h2 style={{ color: "#0D553A" }}>Executive Committee</h2>
                <TableComponent columns={columns} data={rows} />
            </article>
        </section>
    )
}

export default ExecutiveCommittee
